import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { LatLngBounds } from 'leaflet';
export function MapBounds({ paths, cache, stationCoords }) {
    const map = useMap();
    useEffect(() => {
        const allCoords = [];
        if (cache && paths && paths.length > 0) {
            paths.forEach(path => {
                if (path && Array.isArray(path)) {
                    path.forEach(nodeId => {
                        const node = cache.nodes.get(nodeId);
                        if (node) {
                            allCoords.push([node.lat, node.lon]);
                        }
                    });
                }
            });
        }
        if (stationCoords && stationCoords.length > 0) {
            stationCoords.forEach(coord => {
                allCoords.push([coord.lat, coord.lon]);
            });
        }
        if (allCoords.length > 0) {
            const bounds = new LatLngBounds(allCoords);
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [paths, cache, stationCoords, map]);
    return null;
}
